import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('/page/index')
const Login = () => import('/page/Login/login')
const Register = () => import('/page/Login/register')
const Home = () => import('/page/Home/home')
const GoodS = () => import('/page/Goods/goods')
const goodsDetails = () => import('/page/Goods/goodsDetails')
const test = () => import('/page/Goods/test')
const Cart = () => import('/page/Cart/cart')
const order = () => import('/page/Order/order')
const user = () => import('/page/User/user')
const orderList = () => import('/page/User/children/orderList')
const collectList = () => import('/page/User/children/collectList')
const information = () => import('/page/User/children/information')
const addressList = () => import('/page/User/children/addressList')
const coupon = () => import('/page/User/children/coupon')
const support = () => import('/page/User/children/support')
const paidMbr = () => import('/page/User/children/paidMbr')
const checkout = () => import('/page/Checkout/checkout')
const rxcheckout = () => import('/page/Checkout/rxCheckout')
const payment = () => import('/page/Order/payment')
const Search = () => import('/page/Search/search')
const RefreshSearch = () => import('/page/Refresh/refreshsearch')
const RefreshGoods = () => import('/page/Refresh/refreshgoods')
const orderDetail = () => import('/page/User/children/orderDetail')
const supportDetail = () => import('/page/User/children/supportDetail')
const article = () => import('/page/Article/article')
const custompage = () => import('/page/Custompage/custompage')
const promotion = () => import('/page/Promotion/promotion')
const preferential = () => import('/page/Preferential/preferential')

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      name: 'index',
      redirect: '/home',
      children: [
        {path: 'home', component: Home},
        {path: 'goods', component: GoodS},
        {path: 'goodsDetails', name: 'goodsDetails', component: goodsDetails},
        {path: 'test', name: 'test', component: test},
        {path: '/refreshgoods', name: 'refreshgoods', component: RefreshGoods}
      ]
    },
    {path: '/login', name: 'login', component: Login},
    {path: '/register', name: 'register', component: Register},
    {path: '/cart', name: 'cart', component: Cart},
    {path: '/refreshsearch', name: 'refreshsearch', component: RefreshSearch},
    {
      path: '/order',
      name: 'order',
      component: order,
      children: [
				{path: 'payment', name: 'payment', component: payment},
        {path: '/search', name: 'search', component: Search}
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      redirect: '/user/orderList',
      children: [
				{path: 'orderList', name: '我的订单', component: orderList},
        {path: 'rxOrderList', name: '我的预约单', component: orderList},
        {path: 'collectList', name: '我的收藏', component: collectList},
        {path: 'orderDetail', name: '订单详情', component: orderDetail},
        {path: 'information', name: '会员信息', component: information},
        {path: 'addressList', name: '收货地址', component: addressList},
        {path: 'coupon', name: '我的优惠', component: coupon},
        {path: 'support', name: '售后服务', component: support},
        {path: 'supportDetail', name: '售后详情', component: supportDetail},
        {path: 'paidMbr', name: '付费会员', component: paidMbr}
      ]
    },
		{path: '/checkout', name: 'checkout', component: checkout},
    {path: '/rxcheckout', name: 'rxcheckout', component: rxcheckout},
		{path: '*', redirect: '/home'},
    {
      path: '/store',
      name: 'store',
      component: _ => import('/page/Store/index'),
      redirect: '/store/home',
      children: [
        {path: 'home', component: _ => import('/page/Store/storeHome')},
        {path: 'goods', component: _ => import('/page/Store/storeGoods')}
      ]
    },
    {path: '/article', name: 'article', component: article},
    {path: '/custompage', name: 'custompage', component: custompage},
    {path: '/promotion', name: 'promotion', component: promotion},
    {path: '/preferential', name: 'preferential', component: preferential},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js